<template>
  <div class="foot-wrapper ">
    <span>灵宝诚田网络科技有限公司</span>
    <span>豫ICP备20017470号</span>
  </div>
</template>

<script>
export default {
  name: 'footer',
  data () {
    return {
    };
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.foot-wrapper {
  width: 100%;
  min-width: 1100px;
  background: rgba(31, 31, 31, 1);
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #bbb;
  font-size: 12px;
  font-weight: bold;
}

.foot-wrapper span{
  display: block;
}
</style>
